// extracted by mini-css-extract-plugin
export default {"divAbsolute":"style_divAbsolute__-vnQO","divSpinner":"style_divSpinner__yuLFJ","spinner":"style_spinner__CEVEK","spinnerText":"style_spinnerText__-uQpS"};